import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-143cb52b"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "status-item" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "status-label" }, "登录时间：", -1));
const _hoisted_3 = { class: "status-label-text" };
const _hoisted_4 = { class: "status-item" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "status-label" }, "登录设备：", -1));
const _hoisted_6 = { class: "status-label-text" };
const _hoisted_7 = { class: "status-item" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "status-label" }, "登录IP：", -1));
const _hoisted_9 = { class: "status-label-text" };
const _hoisted_10 = { class: "status-item" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "status-label" }, "登录地址：", -1));
const _hoisted_12 = { class: "status-label-text" };
const _hoisted_13 = { class: "noMore" };
import { tokenHistory } from '@/api/exercise';
import Empty from '@/components/common/Empty.vue';
import BScroll from '@/components/common/BetterScroll.vue';
import { ref, onMounted, getCurrentInstance } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { proxy: { $showLoading, $hideLoading } } = getCurrentInstance();
        const listBs = ref(); // 上拉加载
        let loaded = ref(false); // 是否加载完成
        const noMore = ref(false); // 是否还有更多
        var pageNo = 1; //当前页数
        var pageCount = 1; //共有多少页
        const historyList = ref([]);
        const getHistory = () => {
            $showLoading();
            loaded.value = false;
            tokenHistory({
                page: pageNo
            }).then((res) => {
                loaded.value = true;
                $hideLoading();
                if (res.code === 200) {
                    pageCount = res.data.pages;
                    if (pageNo === 1) {
                        historyList.value = res.data.items;
                    }
                    else {
                        historyList.value = historyList.value.concat(res.data.items);
                    }
                    listBs.value?.refreshBs();
                    if (pageNo >= pageCount) {
                        noMore.value = true;
                    }
                    else {
                        noMore.value = false;
                        pageNo++;
                    }
                }
            });
        };
        onMounted(() => {
            getHistory();
            listBs.value?.scrollTo(0, 0);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(BScroll, {
                ref: (_value, _refs) => {
                    _refs['listBs'] = _value;
                    listBs.value = _value;
                },
                options: {
                    scrollY: true,
                    scrollX: false,
                    click: true,
                    mouseWheel: true,
                    scrollbar: {
                        fade: false,
                        interactive: true
                    },
                    pullUpLoad: true
                },
                loaded: _unref(loaded),
                noMore: noMore.value,
                onUpLoad: getHistory,
                domStyle: {
                    position: 'relative',
                    height: 'calc(100vh - 0.9rem)'
                }
            }, {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyList.value, (item, key) => {
                        return (_openBlock(), _createElementBlock("div", {
                            class: "deviceList",
                            key: key
                        }, [
                            _createElementVNode("div", _hoisted_1, [
                                _hoisted_2,
                                _createElementVNode("span", _hoisted_3, _toDisplayString(item.createdDate), 1)
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                                _hoisted_5,
                                _createElementVNode("span", _hoisted_6, _toDisplayString(item.clientTypeName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _hoisted_8,
                                _createElementVNode("span", _hoisted_9, _toDisplayString(item.ip), 1)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _hoisted_11,
                                _createElementVNode("span", _hoisted_12, _toDisplayString(item.city), 1)
                            ])
                        ]));
                    }), 128)),
                    _withDirectives(_createVNode(Empty, null, null, 512), [
                        [_vShow, _unref(pageCount) == 0 && noMore.value]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_13, "没有更多了", 512), [
                        [_vShow, noMore.value && _unref(pageCount) === _unref(pageNo)]
                    ])
                ]),
                _: 1
            }, 8, ["loaded", "noMore", "domStyle"]));
        };
    }
});
